module.exports = __webpack_public_path__ + "static/img/z5.324a56e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/z5.svg
// module id = XVmQ
// module chunks = 1